import React, { useEffect, useState } from 'react';

import { useParams, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '@pwc/pwc-deals-ui';
import { fetchSurveyResponses, getSurveyResponses } from '../../../surveySlice';
import { getFirstQuestionInSection } from '../../../common/services/utilities/surveyUtility';
import { formatSurveyQuestionRoute, formatNextRoute } from '../../../routes';

const SurveyRedirectToQuestionInSection = ({ sectionPath }) => {
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const [redirectPath, setRedirectPath] = useState();

  const surveyResponses = useSelector(getSurveyResponses);

  useEffect(() => {
    if (!surveyResponses) {
      dispatch(fetchSurveyResponses(projectId));
    } else {
      const { sections, questions } = surveyResponses;
      const section = sections.find((s) => s.path === sectionPath);
      let path;

      if (section) {
        const { id: firstQuestionId } = getFirstQuestionInSection(
          questions,
          section.id
        );
        path = formatSurveyQuestionRoute(
          projectId,
          sectionPath,
          firstQuestionId
        );
      } else {
        path = formatNextRoute(projectId);
      }
      setRedirectPath(path);
    }
  }, [dispatch, projectId, surveyResponses, sectionPath]);

  return (
    <>
      {redirectPath && <Redirect to={redirectPath} />}
      {!redirectPath && <Loader />}
    </>
  );
};

export default SurveyRedirectToQuestionInSection;
